import { render, staticRenderFns } from "./messagePager.vue?vue&type=template&id=67269e9c&scoped=true&"
import script from "./messagePager.vue?vue&type=script&lang=js&"
export * from "./messagePager.vue?vue&type=script&lang=js&"
import style0 from "./messagePager.vue?vue&type=style&index=0&id=67269e9c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67269e9c",
  null
  
)

export default component.exports